import React, {useEffect, useState} from 'react';
import {useStyles} from "./styles/AddGroupStyle";
import {
    Box,
    Button,
    FormControl,
    FormControlLabel,
    MenuItem,
    Radio,
    RadioGroup,
    Select,
    TextField,
    Typography
} from "@material-ui/core";
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import {ReactComponent as ArrowDownIcon} from '../../../common/images/ArrowDownIcon.svg';
import {ReactComponent as BeforeBtn} from '../../../common/images/BeforeBtn.svg';
import {ReactComponent as CalendarIcon} from '../../../common/images/CalendarIcon.svg';
import {COMMON_UTIL} from "../../../common/util/common.util";
import {inject, observer} from "mobx-react";
import {injectIntl} from "react-intl";
import dayjs from "dayjs";
import {DATE_UTIL} from "../../../common/util/date/date.util";
import GroupDialog from "./GroupDialog";
import NoImage from '../../../common/images/NoImage.jpg'
import {useHistory} from "react-router-dom";
import {URL_TYPE} from "../../../routes/Routes";
import {USER_TYPE} from "../../../stores/UserStore";
import NoticeViewer from "./NoticeViewer";
import NoticeUploadDialog from "./NoticeUploadDialog";


function AddGroup(props) {
    const classes = useStyles();
    const {intl} = props;
    const history = useHistory();
    const {groupStore, userStore, authStore} = props;

    const [isNoticeDialogOpen, setIsNoticeDialogOpen] = useState(false);
    const [isTooltipVisible, setTooltipVisible] = useState(false);

    const handleEnterLogo = (e) => {
        setTooltipVisible(true);
    }
    const handleLeaveLogo = () => {
        setTooltipVisible(false);
    };

    useEffect(() => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.expiredDate = dayjs().format(DATE_UTIL.FORMAT.DATE_FORMAT);
        groupStore.setNewGroup(newGroup);

        userStore.setLocaleAdminUserIdList([]);
        if (authStore.getUserType() === USER_TYPE.LocaleAdmin) {
            let newGroup = Object.assign({}, groupStore.newGroup);
            newGroup.localeAdminUserId = authStore.loginUser.id;
            groupStore.setNewGroup(newGroup);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const handleChangeLocaleCode = (e) => {
        const localeCode = e.target.value;
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.localeCode = localeCode;
        newGroup.localeAdminUserId = ' ';
        groupStore.setNewGroup(newGroup);

        userStore.getLocaleAdminUserIdList(localeCode);
    }

    const handleChangeLocaleAdminUserId = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.localeAdminUserId = e.target.value;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeLocaleGroupType = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.groupType = e.target.value;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeLocaleGroupName = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.name = e.target.value;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeEnable = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.enable = e.target.value;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeUnlimitedUse = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.unlimitedUse = e.target.value;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeExpiredDate = (date) => {
        const expiredDate = dayjs(date).format(DATE_UTIL.FORMAT.DATE_FORMAT);
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.expiredDate = expiredDate;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeTimeZone = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.timeZone = e.target.value;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeMaxUserCount = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.maxUserCount = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeAiPronunciationCount = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.aiPronunciationCount = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeAiTranslationCount = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.aiTranslationCount = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setNewGroup(newGroup);
    }

    const handleChangeAiChatTime = (e) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.aiChatTime = Number(e.target.value) >= 0 ? Number(e.target.value) : 0;
        groupStore.setNewGroup(newGroup);
    }

    const handleClickDialogOpen = (type) => {
        groupStore.setDialogOpen(true, type);
    }

    const handleClickRemoveLogo = () => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        newGroup.logo = '';
        groupStore.setNewGroup(newGroup);
    }

    const openFileExplorer = () => {
        const input = document.getElementById('logoUpload');
        input.click();
    }

    const uploadLogo = async (e) => {
        const file = e.target.files[0];
        if (file) {
            try {
                const fileType = file.type.split('/')[1];
                const base64String = await convertFileToBase64(file);

                let newGroup = Object.assign({}, groupStore.newGroup);
                newGroup.logo = `data:image/${fileType};base64,` + base64String;
                groupStore.setNewGroup(newGroup);
            } catch (error) {
                console.error('Error converting logo file to base64:', error);
            }
        }
    }

    const convertFileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);

            reader.onload = () => {
                resolve(reader.result.split(',')[1]);
            };

            reader.onerror = (error) => {
                reject(error);
            };
        });
    };

    const handleClickCreateGroup = () => {
        groupStore.addGroup(() => history.push(URL_TYPE.GroupList));
    }

    const canCreate = () => {
        const newGroup = groupStore.newGroup;
        if (newGroup.localeAdminUserId === ' ') {
            return false;
        }
        if (newGroup.groupType === ' ') {
            return false;
        }
        if (newGroup.name === '') {
            return false;
        }
        if (newGroup.unlimitedUse === 'false' && newGroup.expiredDate === '') {
            return false;
        }
        if (newGroup.maxUserCount <= 0) {
            return false;
        }

        return true;
    }

    const getLogoTooltip = () => {
        const logoEl = document.getElementById('logoImage');
        const rect = logoEl.getBoundingClientRect();

        const top = rect.top - (rect.height * 3);
        const left = rect.left + rect.width;

        return (
            <div className={classes.tooltip} style={{top: top, left: left}}>
                <img
                    className="tooltip-image"
                    style={{height: rect.height * 3}}
                    src={group.logo}
                    alt="Logo"
                />
            </div>
        )
    }

    const handleNoticeUpload = async (file, url) => {
        try {
            const fileType = file.type.split('/')[1];
            const base64String = await convertFileToBase64(file);

            const newNotice = {
                id: Date.now(),
                notice: `data:image/${fileType};base64,` + base64String,
                url: url
            };

            let newGroup = Object.assign({}, groupStore.newGroup);
            if (!newGroup.notices) {
                newGroup.notices = [];
            }
            newGroup.notices.push(newNotice);
            groupStore.setNewGroup(newGroup);

            setIsNoticeDialogOpen(false);
        } catch (error) {
            console.error('Error converting notice file to base64:', error);
        }
    }

    const handleNoticeDelete = (noticeId) => {
        let newGroup = Object.assign({}, groupStore.newGroup);
        console.log("modifyGroup.notices:", newGroup.notices);

        newGroup.notices = newGroup.notices.filter(notice => notice.id !== noticeId);
        groupStore.setNewGroup(newGroup);
    }

    const group = groupStore.newGroup;
    console.log('group:', group, group.localeCode)

    return (
        <Box className={classes.root}>
            <Box display={"flex"} justifyContent={"space-between"}>

            </Box>

            <Box className={classes.contentBox}>
                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.groupInfoBox}>
                    <Typography className={classes.groupInfo}>{intl.formatMessage({id: "group_info_and_authority"})}</Typography>
                </Box>
                <Box className={classes.bgBox}>
                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.searchBox}>
                        {authStore.getUserType() === USER_TYPE.Admin &&
                            <>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                    <Typography className={classes.selectText}>{intl.formatMessage({id: "Locale"})}<span>*</span></Typography>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            value={group.localeCode}
                                            onChange={handleChangeLocaleCode}
                                            IconComponent={(props) => (
                                                <Box>
                                                    <ArrowDownIcon  {...props} />
                                                </Box>
                                            )}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "right"
                                                },
                                                transformOrigin:{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                },
                                                getContentAnchorEl: null,
                                                className:classes.selectPopover
                                            }}
                                        >
                                            {group.localeCode === ' ' &&
                                                <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_locale"})}</MenuItem>
                                            }
                                            {COMMON_UTIL.getLocaleList().map((locale, index) => (
                                                <MenuItem key={index} value={locale}>{intl.formatMessage({id: locale})}</MenuItem>
                                            ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                                <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                                    <Typography className={classes.selectText}>{intl.formatMessage({id: "LocaleAdmin"})}<span>*</span></Typography>
                                    <FormControl className={classes.formControl}>
                                        <Select
                                            value={group.localeAdminUserId}
                                            onChange={handleChangeLocaleAdminUserId}
                                            IconComponent={(props) => (
                                                <Box>
                                                    <ArrowDownIcon  {...props} />
                                                </Box>
                                            )}
                                            MenuProps={{
                                                anchorOrigin: {
                                                    vertical: "bottom",
                                                    horizontal: "right"
                                                },
                                                transformOrigin:{
                                                    vertical: 'top',
                                                    horizontal: 'right',
                                                },
                                                getContentAnchorEl: null,
                                                className:classes.selectPopover
                                            }}
                                        >
                                            {group.localeAdminUserId === ' ' &&
                                                <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_admin"})}</MenuItem>
                                            }
                                            {userStore.localeAdminUserIdList.length > 0 &&
                                                userStore.localeAdminUserIdList.map((userId, index) => (
                                                    <MenuItem key={index} value={userId}>{userId}</MenuItem>
                                                ))}
                                        </Select>
                                    </FormControl>
                                </Box>
                            </>
                        }
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={authStore.getUserType() === USER_TYPE.Admin ? {marginLeft: 50} : null}>
                            <Typography className={classes.selectText}>{intl.formatMessage({id: "group_type"})}<span>*</span></Typography>
                            <FormControl className={classes.formControl}>
                                <Select
                                    value={group.groupType}
                                    onChange={handleChangeLocaleGroupType}
                                    IconComponent={(props) => (
                                        <Box>
                                            <ArrowDownIcon  {...props} />
                                        </Box>
                                    )}
                                    MenuProps={{
                                        anchorOrigin: {
                                            vertical: "bottom",
                                            horizontal: "right"
                                        },
                                        transformOrigin:{
                                            vertical: 'top',
                                            horizontal: 'right',
                                        },
                                        getContentAnchorEl: null,
                                        className:classes.selectPopover
                                    }}
                                >
                                    {group.groupType === ' ' &&
                                        <MenuItem value=' '>{intl.formatMessage({id: "msg_info_select_group_type"})}</MenuItem>
                                    }
                                    {COMMON_UTIL.getGroupTypeList().map((type, index) => (
                                        <MenuItem key={index} value={type}>{intl.formatMessage({id: type})}</MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Box>
                    </Box>

                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                            <Box>
                                <Typography className={classes.selectText}>{intl.formatMessage({id: "locale_timezone"})}<span>*</span></Typography>
                                <Typography className={classes.noticeText} style={{color: 'black'}}>(UTC± {intl.formatMessage({id: "hour"})})</Typography>
                            </Box>
                            <Box className={classes.textQuizBox} >
                                <TextField id="outlined-basic" variant="outlined" type="number" value={group.timeZone} onChange={handleChangeTimeZone}/>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                            <Typography className={classes.selectText}>{intl.formatMessage({id: "group_name"})}<span>*</span></Typography>
                            <Box className={classes.textQuizBox} >
                                <TextField id="outlined-basic" variant="outlined" placeholder={intl.formatMessage({id: "group_name"})} value={group.name} onChange={handleChangeLocaleGroupName} />
                            </Box>
                        </Box>
                    </Box>

                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                            <Box>
                                <Typography className={classes.selectText}>{intl.formatMessage({id: "pronunciation_test"})}<span>*</span></Typography>
                                <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "number_of_uses_per_day"})})</Typography>
                            </Box>
                            <Box className={classes.textQuizBox} >
                                <TextField id="outlined-basic" variant="outlined" type="number" value={group.aiPronunciationCount} onChange={handleChangeAiPronunciationCount}/>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                            <Box>
                                <Typography className={classes.selectText}>AI {intl.formatMessage({id: "translation"})}<span>*</span></Typography>
                                <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "number_of_uses_per_day"})})</Typography>
                            </Box>
                            <Box className={classes.textQuizBox} >
                                <TextField id="outlined-basic" variant="outlined" type="number" value={group.aiTranslationCount} onChange={handleChangeAiTranslationCount}/>
                            </Box>
                        </Box>

                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{marginLeft: 50}}>
                            <Box>
                                <Typography className={classes.selectText}>AI {intl.formatMessage({id: "conversation"})}<span>*</span></Typography>
                                <Typography className={classes.noticeText} style={{color: 'black'}}>({intl.formatMessage({id: "seconds_of_uses_per_day"})})</Typography>
                            </Box>
                            <Box className={classes.textQuizBox} >
                                <TextField id="outlined-basic" variant="outlined" type="number" value={group.aiChatTime} onChange={handleChangeAiChatTime}/>
                            </Box>
                        </Box>
                    </Box>

                    <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.threeGrid} sx={{maxWidth: 380}}>
                            <Typography className={classes.selectText}>{intl.formatMessage({id: "use_status"})}<span>*</span></Typography>
                            <Box>
                                <RadioGroup row className={classes.radioGroup} value={group.enable} onChange={handleChangeEnable}>
                                    <FormControlLabel value='true' control={<Radio disableRipple />} label={intl.formatMessage({id: "available"})} />
                                    <FormControlLabel value='false' control={<Radio disableRipple />} label={intl.formatMessage({id: "unavailable"})} />
                                </RadioGroup>
                            </Box>
                        </Box>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.threeGrid} sx={{maxWidth: 500, marginRight: 20}}>
                            <Typography className={classes.selectText}>{intl.formatMessage({id: "use_date"})}<span>*</span></Typography>
                            <Box sx={{width: 235}}>
                                <RadioGroup row className={classes.radioGroup} value={group.unlimitedUse} onChange={handleChangeUnlimitedUse}>
                                    <FormControlLabel value='true' control={<Radio disableRipple />} label={intl.formatMessage({id: "unlimited"})} />
                                    <FormControlLabel value='false' control={<Radio disableRipple />} label={intl.formatMessage({id: "limited"})} />
                                </RadioGroup>
                            </Box>
                            {group.unlimitedUse === 'false' &&
                                <>
                                    <Box>
                                        <Typography className={classes.dueDayText}>{intl.formatMessage({id: "expire_date"})}</Typography>
                                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                            <Box className={classes.datePicker}>
                                                <DatePicker
                                                    showIcon
                                                    icon={
                                                        <CalendarIcon
                                                            style={{
                                                                position: "absolute",
                                                                top: "50%",
                                                                transform: "translateY(-50%)",
                                                                cursor: "pointer",
                                                            }}
                                                        />}
                                                    minDate={new Date()}
                                                    selected={group.expiredDate !== '' ? new Date(group.expiredDate) : new Date()}
                                                    onSelect={(date) => handleChangeExpiredDate(date)}
                                                    dateFormat="yyyy-MM-dd"
                                                    shouldCloseOnSelect={true}
                                                    toggleCalendarOnIconClick
                                                />
                                            </Box>
                                        </Box>
                                        <Typography style={{fontSize: '0.6rem'}} className={classes.noticeText}>{intl.formatMessage({id: "msg_info_expire_date"})}</Typography>
                                    </Box>
                                </>
                            }

                        </Box>
                        <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"} className={classes.threeGrid}>
                            <Typography className={classes.selectText}>{intl.formatMessage({id: "create_account_count"})}<span>*</span></Typography>
                            <Box className={classes.textQuizBox} >
                                <TextField id="outlined-basic" variant="outlined" type="number" value={group.maxUserCount} onChange={handleChangeMaxUserCount}/>
                            </Box>
                        </Box>
                    </Box>

                </Box>
                <Box>
                    <Typography className={classes.boxTitle}>{intl.formatMessage({id: "normal_account_settings"})}</Typography>
                    <Box className={classes.bgBox}>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.mainText}>{intl.formatMessage({id: "group_default_email"})}</Typography>
                                <Typography className={classes.subText}>{intl.formatMessage({id: "group_default_email_description"})}</Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.selectText}>{group.defaultEmail}</Typography>
                                <Button className={classes.setButton} onClick={() => handleClickDialogOpen('email')} disableRipple>
                                    <Typography>{intl.formatMessage({id: "input"})}</Typography>
                                </Button>
                                <GroupDialog />
                            </Box>
                        </Box>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{borderTop: '1px solid #c0c0c0', marginTop: 20, paddingTop: '20px !important'}}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.mainText}>{intl.formatMessage({id: "group_default_password"})}</Typography>
                            </Box>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.selectText}>{group.defaultPassword}</Typography>
                                <Button className={classes.setButton} onClick={() => handleClickDialogOpen('password')} disableRipple>
                                    <Typography>{intl.formatMessage({id: "input"})}</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>

                <Box>
                    <Typography className={classes.boxTitle}>{intl.formatMessage({id: "app_settings"})}</Typography>
                    <Box className={classes.bgBox}>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.mainText}>{intl.formatMessage({id: "logo_image"})}</Typography>
                                <Box className={classes.pic}>
                                    {group.logo !== '' ?
                                        <div className="imageContainer" style={{height: '100%'}}>
                                            <img
                                                id='logoImage'
                                                style={{height: '100%'}}
                                                src={group.logo}
                                                alt="Logo"
                                                onMouseEnter={handleEnterLogo}
                                                onMouseLeave={handleLeaveLogo}
                                            />
                                            {isTooltipVisible &&
                                                getLogoTooltip()
                                            }
                                        </div>
                                        :
                                        <img className={classes.iconBtn} style={{height: '100%'}} src={NoImage} alt='NoImage'/>
                                    }
                                </Box>
                            </Box>
                            <Box>
                                <Button className={classes.setButton} disableRipple onClick={handleClickRemoveLogo} >
                                    <Typography>{intl.formatMessage({id: "delete"})}</Typography>
                                </Button>
                                <Button className={classes.setButton} disableRipple onClick={openFileExplorer} >
                                    <Typography>{intl.formatMessage({id: "register"})}</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                    <Box className={classes.bgBox}>
                        <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                            <Box display={"flex"} justifyContent={"flex-start"} alignItems={"center"}>
                                <Typography className={classes.mainText}>{intl.formatMessage({id: "notice"})}</Typography>
                                <NoticeViewer
                                    notices={groupStore.newGroup.notices || []}
                                    onDelete={handleNoticeDelete}
                                />
                            </Box>
                            <Box>
                                <Button className={classes.setButton} disableRipple onClick={() => setIsNoticeDialogOpen(true)} >
                                    <Typography>{intl.formatMessage({id: "register"})}</Typography>
                                </Button>
                            </Box>
                        </Box>
                    </Box>
                </Box>
            </Box>
            <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} sx={{marginTop: 10}}>
                <Box>
                    <Button className={classes.preBtn} disableRipple onClick={() => history.push(URL_TYPE.GroupList)}>
                        <BeforeBtn />
                        <Typography>{intl.formatMessage({id: "previous"})}</Typography>
                    </Button>
                </Box>
                <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
                    <Button className={classes.finishButton} style={!canCreate() ? {background: '#87888d'} : null} disableRipple onClick={handleClickCreateGroup} disabled={!canCreate()}>
                        <Typography>{intl.formatMessage({id: "complete"})}</Typography>
                    </Button>
                </Box>
            </Box>
            <input id={'logoUpload'} style={{ display: 'none' }} accept={".jpg, .jpeg, .png"} onChange={uploadLogo} placeholder={intl.formatMessage({id: "pull_file"})} type={'file'}/>
            <NoticeUploadDialog
                open={isNoticeDialogOpen}
                onClose={() => setIsNoticeDialogOpen(false)}
                onUpload={handleNoticeUpload}
            />
        </Box>
    );
}

export default inject('groupStore', 'userStore', 'authStore')(injectIntl(observer(AddGroup)));
